export const TOGGLE_MODAL = 'MODAL/TOGGLE_MODAL';
export const CLEAR_MODAL_DATA = 'MODAL/CLEAR_MODAL_DATA';

export function toggleModal(uniqueModalName, data) {
    return {
        data,
        type: TOGGLE_MODAL,
        uniqueModalName
    };
}

export function clearModalData(uniqueModalName) {
    return {
        type: CLEAR_MODAL_DATA,
        uniqueModalName
    };
}
